import { defaultLandingVariant } from "./default";
import {
  aiFaqsVariant,
  forParentsVariant,
  howItWorksVariant,
  ourStoryVariant,
  pricingVariant,
} from "./pages";
import type { LandingVariant } from "./types";

export const landingVariants = [
  defaultLandingVariant,
  howItWorksVariant,
  forParentsVariant,
  aiFaqsVariant,
  pricingVariant,
  ourStoryVariant,
] as const satisfies readonly LandingVariant[];

export function getLandingVariant(slug: string): LandingVariant {
  const variant = landingVariants.find((entry) => entry.slug === slug);
  if (variant === undefined) {
    throw new Error(`Unknown landing variant: ${slug}`);
  }
  return variant;
}
